import * as React from 'react'

import { SVGResponsive } from './common'

function Cross() {
  return (
    <SVGResponsive height={16} width={16}>
      <path
        d="M10.016 7.813l5.14-5.141c.297-.281.469-.672.469-1.11A1.567 1.567 0 0 0 12.953.454L7.813 5.61 2.671.453A1.567 1.567 0 0 0 .453 2.672l5.156 5.14-5.14 5.141A1.509 1.509 0 0 0 0 14.063a1.567 1.567 0 0 0 2.672 1.109l5.14-5.156 5.141 5.14c.281.297.672.469 1.11.469a1.567 1.567 0 0 0 1.109-2.672l-5.156-5.14z"
        fill="currentColor"
      />
    </SVGResponsive>
  )
}

export default React.memo(Cross)
